import React, { useState, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@material-ui/core/Box";

import { toast } from "react-toastify";

import api from "../../services/api";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    overflowY: "auto"
  },
  field: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  warn: {
    background: "#fff3cd",
    color: "#856404",
    padding: theme.spacing(1.5),
    borderRadius: 4,
    marginBottom: theme.spacing(2),
    border: "1px solid #ffe69c"
  }
}));

const Campaigns = () => {
  const classes = useStyles();

  const [contacts, setContacts] = useState([]);
  const [selected, setSelected] = useState({});
  const [templateName, setTemplateName] = useState("");
  const [languageCode, setLanguageCode] = useState("pt_BR");
  const [bodyParams, setBodyParams] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [result, setResult] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/contacts", {
          params: { searchParam: "", pageNumber: 1 }
        });
        setContacts(data.contacts || []);
      } catch (err) {
        toastError(err);
      }
      try {
        const { data } = await api.get("/meta-campaign/status");
        setStatus(data);
      } catch (err) {
        /* status é opcional */
      }
    })();
  }, []);

  const toggle = id =>
    setSelected(prev => ({ ...prev, [id]: !prev[id] }));

  const selectedIds = () =>
    Object.keys(selected)
      .filter(id => selected[id])
      .map(Number);

  const handleSend = async () => {
    const ids = selectedIds();
    if (!ids.length) {
      toast.warn("Selecione ao menos um contato.");
      return;
    }
    if (!templateName) {
      toast.warn("Informe o nome do template aprovado na Meta.");
      return;
    }
    setLoading(true);
    setResult(null);
    try {
      const params = bodyParams.trim()
        ? bodyParams.split(",").map(s => s.trim())
        : [];
      const { data } = await api.post("/meta-campaign/send", {
        contactIds: ids,
        templateName,
        languageCode,
        bodyParams: params
      });
      setResult(data);
      toast.success(
        `Disparo concluído: ${data.sent} enviados, ${data.failed} falhas.`
      );
    } catch (err) {
      toastError(err);
    }
    setLoading(false);
  };

  return (
    <MainContainer>
      <MainHeader>
        <Title>Disparo (WhatsApp oficial)</Title>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        {status && !status.configured && (
          <div className={classes.warn}>
            ⚠ WhatsApp oficial (Meta) ainda não configurado — defina um
            WA_ACCESS_TOKEN válido no servidor. O disparo só funcionará depois
            disso.
          </div>
        )}
        <Typography variant="body2" style={{ marginBottom: 12 }}>
          Envia um <b>template aprovado pela Meta</b> para os contatos
          selecionados. Disparo oficial — sem risco de ban, mas exige template
          aprovado e que o cliente tenha aceitado receber (opt-in).
        </Typography>
        <div>
          <TextField
            className={classes.field}
            label="Nome do template"
            value={templateName}
            onChange={e => setTemplateName(e.target.value)}
            variant="outlined"
            size="small"
          />
          <TextField
            className={classes.field}
            label="Idioma"
            value={languageCode}
            onChange={e => setLanguageCode(e.target.value)}
            variant="outlined"
            size="small"
          />
          <TextField
            className={classes.field}
            label="Parâmetros do corpo (vírgula)"
            value={bodyParams}
            onChange={e => setBodyParams(e.target.value)}
            variant="outlined"
            size="small"
            style={{ minWidth: 300 }}
          />
        </div>
        <Box mt={1} mb={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSend}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={22} />
            ) : (
              "Disparar para selecionados"
            )}
          </Button>
        </Box>
        {result && (
          <Typography variant="body2" style={{ margin: "8px 0" }}>
            Resultado: <b>{result.sent}</b> enviados, <b>{result.failed}</b>{" "}
            falhas de {result.total}.
          </Typography>
        )}
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox" />
              <TableCell>Nome</TableCell>
              <TableCell>Número</TableCell>
              {result && <TableCell>Status</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {contacts.map(c => {
              const r =
                result && result.results.find(x => x.contactId === c.id);
              return (
                <TableRow key={c.id}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={!!selected[c.id]}
                      onChange={() => toggle(c.id)}
                    />
                  </TableCell>
                  <TableCell>{c.name}</TableCell>
                  <TableCell>{c.number}</TableCell>
                  {result && (
                    <TableCell>
                      {r
                        ? r.ok
                          ? "✓ enviado"
                          : `✗ ${r.error || "falha"}`
                        : "-"}
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    </MainContainer>
  );
};

export default Campaigns;
